import React, { Component } from "react";
import { NavLink, Link } from "react-router-dom";
import { withRouter } from "react-router-dom";
//Stateless Functional Component

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser } from "@fortawesome/free-solid-svg-icons";
class NavBar extends Component {
  state = {};
  render() {
    var styleNavBar = "navbar navbar-light fixed-bottom bg-light";
    if (this.props.location.pathname === "/") {
      //styleNavBar += " tabbar";
    }

    // return <div />;
    return (
      <nav className={styleNavBar}>
        <NavLink
          exact={true}
          to="/"
          className="navbar-link btn brn_primary navbar_btn"
          activeClassName="btn_yaystack_active"
        >
          <ion-icon
            class="yaystack_icon_navBar ion-icon"
            name="ios-home"
            style={{ fontSize: "28px" }}
          />
        </NavLink>

        {/* <NavLink
          exact={true}
          to="/search"
          className="navbar-link btn brn_primary navbar_btn"
          activeClassName="btn_yaystack_active"
        >
          <ion-icon class="yaystack_icon_navBar ion-icon" name="ios-search" />
        </NavLink>

        <Link to="/create" className="navbar-link navbar-link-add">
          <button className="btn brn_primary btn_yaystack navbar-add ">
            <ion-icon class="ion-icon" name="ios-add" />
          </button>
        </Link>

        <NavLink
          exact={true}
          to="/question"
          className="navbar-link btn brn_primary navbar_btn"
          activeClassName="btn_yaystack_active"
        >
          <ion-icon class="yaystack_icon_navBar ion-icon" name="text" />
        </NavLink> */}

        <NavLink
          to="/profile"
          className="navbar-link btn brn_primary navbar_btn btn-light"
          activeClassName="btn_yaystack_active"
        >
          <FontAwesomeIcon
            className=""
            icon={faUser}
            style={{ fontSize: "22px" }}
          />
        </NavLink>
      </nav>
    );
  }
}

export default withRouter(NavBar);



// WEBPACK FOOTER //
// ./src/components/navBar.jsx